import Card from './component/card/Card';

import desktopImg from "./imgs/image-product-desktop.jpg"
import mobileImg from "./imgs/image-product-mobile.jpg"

import './App.css';


function App() {
  return (
    <div className="App">
      <Card desktopImg={desktopImg} mobileImg={mobileImg} type="perfume" title="Gabrielle Essence Eau De parfum" desc="A floral, solar and voluptuous interpretation composed by Olivier Polge, Perfumer-Creator for the House of CHANEL." discountedPrice="149.99" normalPrice="169.99"/>
    </div>
  );
}

export default App;